import styled, { css } from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SWReactIcons } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";

export const PageContainer = styled(FlexColumn)`
    align-items: center;
    > * {
        box-sizing: border-box;
    }
`;
export const ContainerWrapper = styled(FlexColumn)`
    padding-top: 48px;
    width: 58%;
    max-width: 904px;
    min-width: 704px;
`;
export const Header = styled(FlexColumn)`
    align-items: center;
    width: 100%;
    padding-bottom: 32px;
    @media (max-width: 1600px) {
        padding-bottom: 24px;
    }
    @media (max-width: 1400px) {
        padding-bottom: 18px;
    }
`;
export const HeaderTitle = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;

export const HomePageBannerWrapper = styled(FlexRow)`
    justify-content: flex-end;
    align-items: center;
    flex: 1 0 auto;
`;

export const ProgressBarActivationWizard = styled(FlexRow)<{ isOpen: boolean }>`
    width: 100%;
    align-items: center;
    overflow: ${({ isOpen }) => (isOpen ? "auto" : "hidden")};
    opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
    max-height: ${({ isOpen }) => (isOpen ? 30 : 0)}px;
    transition: 0.5s ease-in-out;
    @media (max-width: 1400px) {
        margin-top: -6px;
    }
`;

export const ImgStyle = styled.img`
    align-items: center;
    height: 35px;
    margin-bottom: 8px;
    @media (max-width: 1400px) {
        height: 25px;
    }
`;
export const Title = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
    @media (max-width: 1600px) {
        ${setFontVariant("h3", colorsPalettes.carbon[500])}
    }
    @media (max-width: 1400px) {
        ${setFontVariant("h4", colorsPalettes.carbon[500])}
    }
`;
export const BannerTrialText = styled.div`
    padding-right: 12px;
    ${setFontVariant("body1", colorsPalettes.carbon[300])};
    @media (max-width: 1600px) {
        ${setFontVariant("input2", colorsPalettes.carbon[300])}
    }
`;
export const BannerNoTouchText = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    @media (max-width: 1600px) {
        ${setFontVariant("input2", colorsPalettes.carbon[400])}
    }
`;
export const BoldLeftDayText = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[300])};
    @media (max-width: 1600px) {
        ${setFontVariant("subtitle2", colorsPalettes.carbon[300])}
    }
`;
export const AutocompleteWrapper = styled.div`
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    width: 100%;
    margin-bottom: 54px;
    @media (max-width: 1600px) {
        margin-bottom: 46px;
    }
    @media (max-width: 1400px) {
        margin-bottom: 36px;
    }

    & div.AutoCompleteContainer {
        z-index: 5;
    }
`;

export const WidgetWrapperWithTransition = styled(FlexColumn)<{
    isWidgetOpen: boolean;
    componentHeight: number;
}>`
    overflow: ${({ isWidgetOpen }) => (isWidgetOpen ? "auto" : "hidden")};
    opacity: ${({ isWidgetOpen }) => (isWidgetOpen ? "1" : "0")};
    transition:
        max-height 0.25s ease-in-out,
        opacity 0.25s 0.25s ease-in-out;
    transition-delay: ${({ isWidgetOpen }) => (isWidgetOpen ? 0.5 : 0)};
    max-height: ${({ isWidgetOpen, componentHeight }) => (isWidgetOpen ? componentHeight : 0)}px;
    padding-bottom: ${({ isWidgetOpen }) => (isWidgetOpen ? "62px" : "0px")};
    @media (max-width: 1600px) {
        padding-bottom: ${({ isWidgetOpen }) => (isWidgetOpen ? "54px" : "0px")};
    }
    @media (max-width: 1400px) {
        padding-bottom: ${({ isWidgetOpen }) => (isWidgetOpen ? "36px" : "0px")};
    }
`;
export const WidgetWrapper = styled(FlexColumn)<{
    displayed?: boolean;
}>(
    ({ displayed = true }) => css`
        display: ${displayed ? "flex" : "none"};
        padding-bottom: 62px;
        @media (max-width: 1600px) {
            padding-bottom: 45px;
        }
        @media (max-width: 1400px) {
            padding-bottom: 36px;
        }
    `,
);

export const TitleWidget = styled.div`
    ${setFontVariant("tab", colorsPalettes.carbon[500])}
    padding-bottom: 22px;
    @media (max-width: 1400px) {
        padding-bottom: 16px;
    }
`;
export const TextButtonTrial = styled.span`
    ${setFontVariant("button", colorsPalettes.indigo[300])}
`;

export const StyledIconButton = styled(IconButton)`
    cursor: pointer;
    ${SWReactIcons} {
        path {
            fill: ${colorsPalettes.indigo[300]} !important;
        }
    }
    &:hover {
        ${SWReactIcons} {
            path {
                fill: ${colorsPalettes.indigo[500]} !important;
            }
        }
        & ${TextButtonTrial} {
            ${setFontVariant("button", colorsPalettes.indigo[500])}
        }
    }
`;

export const colorButtonTrial = colorsPalettes.indigo[100];

export const StyledPromotionalPackageText = styled.div`
    margin-left: 8px;
    ${setFontVariant("tab", colorsPalettes.carbon[400])};
`;

export const StyledPromotionalIcon = styled(SWReactIcons)`
    display: flex;
    padding: 4px;
    margin: 0 8px 0 4px;
    & svg {
        width: 16px;
        height: 16px;
    }
`;
